// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.portal-branded.dashboard {
  background: var(--portal-content-bg, #eef2f7);
  color: var(--portal-content-text, #0f172a);
}

.portal-branded .topbar {
  background: #fff;
  color: var(--portal-header-text, #0f172a);
}

.portal-branded .sidebar {
  background: #f1f3f9;
}

.portal-branded .sidebar .portal-brand-header h1 {
  color: var(--portal-link, #3f51b5);
}

.portal-branded .sidebar-link,
.portal-branded .sidebar-group-trigger,
.portal-branded .sidebar-sublink {
  color: #475569;
}

.portal-branded .sidebar-link.is-active,
.portal-branded .sidebar-sublink.is-active,
.portal-branded .sidebar-group.is-active > .sidebar-group-trigger {
  color: var(--portal-link, #3f51b5);
  background: color-mix(in srgb, var(--portal-link, #3f51b5) 12%, #fff);
  box-shadow: none;
}

.portal-branded .dashboard-main {
  color: var(--portal-content-text, #0f172a);
}

.portal-branded .dashboard-main .muted {
  color: color-mix(in srgb, var(--portal-content-text, #0f172a) 55%, transparent);
}

.portal-branded a {
  color: var(--portal-link, #1d4ed8);
}

.portal-branded .header-nav-link.is-active,
.portal-branded .dashboard-header .header-nav-link.is-active,
.portal-branded .nav-dropdown.is-active .nav-dropdown-trigger {
  color: var(--portal-link, #4f46e5);
  background: transparent;
  border-color: transparent;
  box-shadow: inset 0 -2px 0 var(--portal-link, #4f46e5);
}

.portal-branded .workspace-tab.active {
  background: transparent;
  color: var(--portal-link, #4f46e5);
  border-color: transparent;
  box-shadow: inset 0 -2px 0 var(--portal-link, #4f46e5);
}

.portal-branded .btn-primary,
.portal-branded .btn-secondary,
.portal-branded .btn-danger,
.portal-branded .btn-link {
  border-radius: var(--btn-radius, 0.45rem);
}

.portal-branded .form-control,
.portal-branded .form-select,
.portal-branded .field > input:not([type='checkbox']):not([type='radio']),
.portal-branded .field > textarea,
.portal-branded .field > select,
.portal-branded .searchable-select-trigger {
  border-radius: var(--btn-radius, 0.45rem);
}

.portal-branded .search-form .form-control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.portal-branded .search-form .btn-secondary,
.portal-branded .search-form .btn-primary {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.portal-branded .btn-primary {
  background: var(--btn-primary-bg, #0f172a);
  color: var(--btn-primary-color, #fff);
  border-color: var(--btn-primary-border, transparent);
}

.portal-branded .btn-secondary {
  background: var(--btn-secondary-bg, #fff);
  color: var(--btn-secondary-color, #0f172a);
  border-color: var(--btn-secondary-border, #cbd5e1);
}

.portal-branded .btn-danger {
  background: var(--btn-danger-bg, #b91c1c);
  color: var(--btn-danger-color, #fff);
  border-color: var(--btn-danger-border, #b91c1c);
}

.portal-branded .btn-link {
  background: var(--btn-link-bg, transparent);
  color: var(--btn-link-color, #0f172a);
  border-color: var(--btn-link-border, #cbd5e1);
}

.portal-branded .btn-link:hover {
  background: var(--btn-link-hover-bg, #f8fafc);
}

.portal-branded[data-button-preset='classic'] {
  --btn-radius: 0.45rem;
  --btn-primary-bg: #0f172a;
  --btn-primary-color: #fff;
  --btn-primary-border: #0f172a;
  --btn-secondary-bg: #fff;
  --btn-secondary-color: #0f172a;
  --btn-secondary-border: #cbd5e1;
  --btn-danger-bg: #b91c1c;
  --btn-danger-color: #fff;
  --btn-danger-border: #b91c1c;
  --btn-link-color: #0f172a;
  --btn-link-border: #cbd5e1;
  --btn-link-hover-bg: #f8fafc;
}

.portal-branded[data-button-preset='ocean'] {
  --btn-radius: 0.45rem;
  --btn-primary-bg: #1d4ed8;
  --btn-primary-color: #fff;
  --btn-primary-border: #1d4ed8;
  --btn-secondary-bg: #eff6ff;
  --btn-secondary-color: #1e3a8a;
  --btn-secondary-border: #93c5fd;
  --btn-danger-bg: #dc2626;
  --btn-danger-color: #fff;
  --btn-danger-border: #dc2626;
  --btn-link-color: #1d4ed8;
  --btn-link-border: #bfdbfe;
  --btn-link-hover-bg: #eff6ff;
}

.portal-branded[data-button-preset='forest'] {
  --btn-radius: 0.45rem;
  --btn-primary-bg: #15803d;
  --btn-primary-color: #fff;
  --btn-primary-border: #15803d;
  --btn-secondary-bg: #f0fdf4;
  --btn-secondary-color: #14532d;
  --btn-secondary-border: #86efac;
  --btn-danger-bg: #b45309;
  --btn-danger-color: #fff;
  --btn-danger-border: #b45309;
  --btn-link-color: #15803d;
  --btn-link-border: #bbf7d0;
  --btn-link-hover-bg: #f0fdf4;
}

.portal-branded[data-button-preset='sunset'] {
  --btn-radius: 0.5rem;
  --btn-primary-bg: #ea580c;
  --btn-primary-color: #fff;
  --btn-primary-border: #ea580c;
  --btn-secondary-bg: #fff7ed;
  --btn-secondary-color: #9a3412;
  --btn-secondary-border: #fdba74;
  --btn-danger-bg: #dc2626;
  --btn-danger-color: #fff;
  --btn-danger-border: #dc2626;
  --btn-link-color: #c2410c;
  --btn-link-border: #fed7aa;
  --btn-link-hover-bg: #fff7ed;
}

.portal-branded[data-button-preset='berry'] {
  --btn-radius: 0.5rem;
  --btn-primary-bg: #7c3aed;
  --btn-primary-color: #fff;
  --btn-primary-border: #7c3aed;
  --btn-secondary-bg: #f5f3ff;
  --btn-secondary-color: #5b21b6;
  --btn-secondary-border: #c4b5fd;
  --btn-danger-bg: #e11d48;
  --btn-danger-color: #fff;
  --btn-danger-border: #e11d48;
  --btn-link-color: #7c3aed;
  --btn-link-border: #ddd6fe;
  --btn-link-hover-bg: #f5f3ff;
}

.portal-branded[data-button-preset='crimson'] {
  --btn-radius: 0.35rem;
  --btn-primary-bg: #b91c1c;
  --btn-primary-color: #fff;
  --btn-primary-border: #b91c1c;
  --btn-secondary-bg: #fff;
  --btn-secondary-color: #7f1d1d;
  --btn-secondary-border: #fca5a5;
  --btn-danger-bg: #881337;
  --btn-danger-color: #fff;
  --btn-danger-border: #881337;
  --btn-link-color: #b91c1c;
  --btn-link-border: #fecaca;
  --btn-link-hover-bg: #fef2f2;
}

.portal-branded[data-button-preset='midnight'] {
  --btn-radius: 0.4rem;
  --btn-primary-bg: #1e3a8a;
  --btn-primary-color: #fff;
  --btn-primary-border: #1e3a8a;
  --btn-secondary-bg: #0f172a;
  --btn-secondary-color: #f8fafc;
  --btn-secondary-border: #334155;
  --btn-danger-bg: #be123c;
  --btn-danger-color: #fff;
  --btn-danger-border: #be123c;
  --btn-link-color: #93c5fd;
  --btn-link-border: #334155;
  --btn-link-hover-bg: #1e293b;
}

.portal-branded[data-button-preset='teal'] {
  --btn-radius: 0.55rem;
  --btn-primary-bg: #0d9488;
  --btn-primary-color: #fff;
  --btn-primary-border: #0d9488;
  --btn-secondary-bg: #f0fdfa;
  --btn-secondary-color: #115e59;
  --btn-secondary-border: #5eead4;
  --btn-danger-bg: #e11d48;
  --btn-danger-color: #fff;
  --btn-danger-border: #e11d48;
  --btn-link-color: #0f766e;
  --btn-link-border: #99f6e4;
  --btn-link-hover-bg: #f0fdfa;
}

.portal-branded[data-button-preset='charcoal'] {
  --btn-radius: 0.25rem;
  --btn-primary-bg: #18181b;
  --btn-primary-color: #fff;
  --btn-primary-border: #18181b;
  --btn-secondary-bg: #fafafa;
  --btn-secondary-color: #27272a;
  --btn-secondary-border: #d4d4d8;
  --btn-danger-bg: #52525b;
  --btn-danger-color: #fff;
  --btn-danger-border: #52525b;
  --btn-link-color: #3f3f46;
  --btn-link-border: #e4e4e7;
  --btn-link-hover-bg: #f4f4f5;
}

.portal-branded[data-button-preset='coral'] {
  --btn-radius: 999px;
  --btn-primary-bg: #f43f5e;
  --btn-primary-color: #fff;
  --btn-primary-border: #f43f5e;
  --btn-secondary-bg: #fff1f2;
  --btn-secondary-color: #be123c;
  --btn-secondary-border: #fda4af;
  --btn-danger-bg: #9f1239;
  --btn-danger-color: #fff;
  --btn-danger-border: #9f1239;
  --btn-link-color: #e11d48;
  --btn-link-border: #fecdd3;
  --btn-link-hover-bg: #fff1f2;
}

.portal-brand-logo {
  width: 2.25rem;
  height: 2.25rem;
  object-fit: contain;
  border-radius: 0.35rem;
  flex-shrink: 0;
}

.portal-brand-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.branding-preset-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(17rem, 1fr));
  gap: 0.75rem;
}

.branding-preset-card {
  border: 2px solid #e2e8f0;
  border-radius: 0.65rem;
  padding: 0.75rem;
  cursor: pointer;
  background: #fff;
  text-align: left;
}

.branding-preset-card:hover {
  border-color: #cbd5e1;
}

.branding-preset-card.is-selected {
  border-color: #1d4ed8;
  box-shadow: 0 0 0 1px #1d4ed8;
}

.branding-preset-card__title {
  margin: 0 0 0.15rem;
  font-size: 0.95rem;
  font-weight: 600;
}

.branding-preset-card__desc {
  margin: 0 0 0.65rem;
  font-size: 0.78rem;
  color: #64748b;
}

.branding-preset-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  align-items: center;
}

.branding-preset-preview .btn-primary,
.branding-preset-preview .btn-secondary,
.branding-preset-preview .btn-danger,
.branding-preset-preview .btn-link {
  padding: 0.3rem 0.55rem;
  font-size: 0.75rem;
}

.branding-color-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(12rem, 1fr));
  gap: 0.75rem;
}

.branding-color-field {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.branding-color-field input[type='color'] {
  width: 2.5rem;
  height: 2.5rem;
  padding: 0;
  border: 1px solid #cbd5e1;
  border-radius: 0.35rem;
  cursor: pointer;
  background: transparent;
}

.field-label {
  display: block;
  font-weight: 600;
  font-size: 0.95rem;
}

.branding-logo-preview {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 0.5rem;
}

.branding-logo-preview img {
  max-width: 8rem;
  max-height: 4rem;
  object-fit: contain;
  border: 1px solid #e2e8f0;
  border-radius: 0.35rem;
  padding: 0.35rem;
  background: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/branding/portal-branding.css"],"names":[],"mappings":"AAAA;EACE,6CAA6C;EAC7C,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,kCAAkC;EAClC,qEAAqE;EACrE,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;;EAGE,kCAAkC;EAClC,uBAAuB;EACvB,yBAAyB;EACzB,sDAAsD;AACxD;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,yBAAyB;EACzB,sDAAsD;AACxD;;AAEA;;;;EAIE,yCAAyC;AAC3C;;AAEA;;;;;;EAME,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,0CAA0C;EAC1C,qCAAqC;EACrC,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;EACzC,0CAA0C;EAC1C,kDAAkD;AACpD;;AAEA;EACE,yCAAyC;EACzC,oCAAoC;EACpC,+CAA+C;AACjD;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,+BAA+B;EAC/B,wBAAwB;EACxB,wBAAwB;EACxB,4BAA4B;EAC5B,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,+BAA+B;EAC/B,wBAAwB;EACxB,wBAAwB;EACxB,4BAA4B;EAC5B,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,+BAA+B;EAC/B,wBAAwB;EACxB,wBAAwB;EACxB,4BAA4B;EAC5B,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,+BAA+B;EAC/B,wBAAwB;EACxB,wBAAwB;EACxB,4BAA4B;EAC5B,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,+BAA+B;EAC/B,wBAAwB;EACxB,wBAAwB;EACxB,4BAA4B;EAC5B,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,+BAA+B;EAC/B,wBAAwB;EACxB,wBAAwB;EACxB,4BAA4B;EAC5B,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,+BAA+B;EAC/B,wBAAwB;EACxB,wBAAwB;EACxB,4BAA4B;EAC5B,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,+BAA+B;EAC/B,wBAAwB;EACxB,wBAAwB;EACxB,4BAA4B;EAC5B,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,+BAA+B;EAC/B,wBAAwB;EACxB,wBAAwB;EACxB,4BAA4B;EAC5B,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,+BAA+B;EAC/B,wBAAwB;EACxB,wBAAwB;EACxB,4BAA4B;EAC5B,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;;;EAIE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,UAAU;EACV,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":[".portal-branded.dashboard {\n  background: var(--portal-content-bg, #eef2f7);\n  color: var(--portal-content-text, #0f172a);\n}\n\n.portal-branded .topbar {\n  background: #fff;\n  color: var(--portal-header-text, #0f172a);\n}\n\n.portal-branded .sidebar {\n  background: #f1f3f9;\n}\n\n.portal-branded .sidebar .portal-brand-header h1 {\n  color: var(--portal-link, #3f51b5);\n}\n\n.portal-branded .sidebar-link,\n.portal-branded .sidebar-group-trigger,\n.portal-branded .sidebar-sublink {\n  color: #475569;\n}\n\n.portal-branded .sidebar-link.is-active,\n.portal-branded .sidebar-sublink.is-active,\n.portal-branded .sidebar-group.is-active > .sidebar-group-trigger {\n  color: var(--portal-link, #3f51b5);\n  background: color-mix(in srgb, var(--portal-link, #3f51b5) 12%, #fff);\n  box-shadow: none;\n}\n\n.portal-branded .dashboard-main {\n  color: var(--portal-content-text, #0f172a);\n}\n\n.portal-branded .dashboard-main .muted {\n  color: color-mix(in srgb, var(--portal-content-text, #0f172a) 55%, transparent);\n}\n\n.portal-branded a {\n  color: var(--portal-link, #1d4ed8);\n}\n\n.portal-branded .header-nav-link.is-active,\n.portal-branded .dashboard-header .header-nav-link.is-active,\n.portal-branded .nav-dropdown.is-active .nav-dropdown-trigger {\n  color: var(--portal-link, #4f46e5);\n  background: transparent;\n  border-color: transparent;\n  box-shadow: inset 0 -2px 0 var(--portal-link, #4f46e5);\n}\n\n.portal-branded .workspace-tab.active {\n  background: transparent;\n  color: var(--portal-link, #4f46e5);\n  border-color: transparent;\n  box-shadow: inset 0 -2px 0 var(--portal-link, #4f46e5);\n}\n\n.portal-branded .btn-primary,\n.portal-branded .btn-secondary,\n.portal-branded .btn-danger,\n.portal-branded .btn-link {\n  border-radius: var(--btn-radius, 0.45rem);\n}\n\n.portal-branded .form-control,\n.portal-branded .form-select,\n.portal-branded .field > input:not([type='checkbox']):not([type='radio']),\n.portal-branded .field > textarea,\n.portal-branded .field > select,\n.portal-branded .searchable-select-trigger {\n  border-radius: var(--btn-radius, 0.45rem);\n}\n\n.portal-branded .search-form .form-control {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.portal-branded .search-form .btn-secondary,\n.portal-branded .search-form .btn-primary {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.portal-branded .btn-primary {\n  background: var(--btn-primary-bg, #0f172a);\n  color: var(--btn-primary-color, #fff);\n  border-color: var(--btn-primary-border, transparent);\n}\n\n.portal-branded .btn-secondary {\n  background: var(--btn-secondary-bg, #fff);\n  color: var(--btn-secondary-color, #0f172a);\n  border-color: var(--btn-secondary-border, #cbd5e1);\n}\n\n.portal-branded .btn-danger {\n  background: var(--btn-danger-bg, #b91c1c);\n  color: var(--btn-danger-color, #fff);\n  border-color: var(--btn-danger-border, #b91c1c);\n}\n\n.portal-branded .btn-link {\n  background: var(--btn-link-bg, transparent);\n  color: var(--btn-link-color, #0f172a);\n  border-color: var(--btn-link-border, #cbd5e1);\n}\n\n.portal-branded .btn-link:hover {\n  background: var(--btn-link-hover-bg, #f8fafc);\n}\n\n.portal-branded[data-button-preset='classic'] {\n  --btn-radius: 0.45rem;\n  --btn-primary-bg: #0f172a;\n  --btn-primary-color: #fff;\n  --btn-primary-border: #0f172a;\n  --btn-secondary-bg: #fff;\n  --btn-secondary-color: #0f172a;\n  --btn-secondary-border: #cbd5e1;\n  --btn-danger-bg: #b91c1c;\n  --btn-danger-color: #fff;\n  --btn-danger-border: #b91c1c;\n  --btn-link-color: #0f172a;\n  --btn-link-border: #cbd5e1;\n  --btn-link-hover-bg: #f8fafc;\n}\n\n.portal-branded[data-button-preset='ocean'] {\n  --btn-radius: 0.45rem;\n  --btn-primary-bg: #1d4ed8;\n  --btn-primary-color: #fff;\n  --btn-primary-border: #1d4ed8;\n  --btn-secondary-bg: #eff6ff;\n  --btn-secondary-color: #1e3a8a;\n  --btn-secondary-border: #93c5fd;\n  --btn-danger-bg: #dc2626;\n  --btn-danger-color: #fff;\n  --btn-danger-border: #dc2626;\n  --btn-link-color: #1d4ed8;\n  --btn-link-border: #bfdbfe;\n  --btn-link-hover-bg: #eff6ff;\n}\n\n.portal-branded[data-button-preset='forest'] {\n  --btn-radius: 0.45rem;\n  --btn-primary-bg: #15803d;\n  --btn-primary-color: #fff;\n  --btn-primary-border: #15803d;\n  --btn-secondary-bg: #f0fdf4;\n  --btn-secondary-color: #14532d;\n  --btn-secondary-border: #86efac;\n  --btn-danger-bg: #b45309;\n  --btn-danger-color: #fff;\n  --btn-danger-border: #b45309;\n  --btn-link-color: #15803d;\n  --btn-link-border: #bbf7d0;\n  --btn-link-hover-bg: #f0fdf4;\n}\n\n.portal-branded[data-button-preset='sunset'] {\n  --btn-radius: 0.5rem;\n  --btn-primary-bg: #ea580c;\n  --btn-primary-color: #fff;\n  --btn-primary-border: #ea580c;\n  --btn-secondary-bg: #fff7ed;\n  --btn-secondary-color: #9a3412;\n  --btn-secondary-border: #fdba74;\n  --btn-danger-bg: #dc2626;\n  --btn-danger-color: #fff;\n  --btn-danger-border: #dc2626;\n  --btn-link-color: #c2410c;\n  --btn-link-border: #fed7aa;\n  --btn-link-hover-bg: #fff7ed;\n}\n\n.portal-branded[data-button-preset='berry'] {\n  --btn-radius: 0.5rem;\n  --btn-primary-bg: #7c3aed;\n  --btn-primary-color: #fff;\n  --btn-primary-border: #7c3aed;\n  --btn-secondary-bg: #f5f3ff;\n  --btn-secondary-color: #5b21b6;\n  --btn-secondary-border: #c4b5fd;\n  --btn-danger-bg: #e11d48;\n  --btn-danger-color: #fff;\n  --btn-danger-border: #e11d48;\n  --btn-link-color: #7c3aed;\n  --btn-link-border: #ddd6fe;\n  --btn-link-hover-bg: #f5f3ff;\n}\n\n.portal-branded[data-button-preset='crimson'] {\n  --btn-radius: 0.35rem;\n  --btn-primary-bg: #b91c1c;\n  --btn-primary-color: #fff;\n  --btn-primary-border: #b91c1c;\n  --btn-secondary-bg: #fff;\n  --btn-secondary-color: #7f1d1d;\n  --btn-secondary-border: #fca5a5;\n  --btn-danger-bg: #881337;\n  --btn-danger-color: #fff;\n  --btn-danger-border: #881337;\n  --btn-link-color: #b91c1c;\n  --btn-link-border: #fecaca;\n  --btn-link-hover-bg: #fef2f2;\n}\n\n.portal-branded[data-button-preset='midnight'] {\n  --btn-radius: 0.4rem;\n  --btn-primary-bg: #1e3a8a;\n  --btn-primary-color: #fff;\n  --btn-primary-border: #1e3a8a;\n  --btn-secondary-bg: #0f172a;\n  --btn-secondary-color: #f8fafc;\n  --btn-secondary-border: #334155;\n  --btn-danger-bg: #be123c;\n  --btn-danger-color: #fff;\n  --btn-danger-border: #be123c;\n  --btn-link-color: #93c5fd;\n  --btn-link-border: #334155;\n  --btn-link-hover-bg: #1e293b;\n}\n\n.portal-branded[data-button-preset='teal'] {\n  --btn-radius: 0.55rem;\n  --btn-primary-bg: #0d9488;\n  --btn-primary-color: #fff;\n  --btn-primary-border: #0d9488;\n  --btn-secondary-bg: #f0fdfa;\n  --btn-secondary-color: #115e59;\n  --btn-secondary-border: #5eead4;\n  --btn-danger-bg: #e11d48;\n  --btn-danger-color: #fff;\n  --btn-danger-border: #e11d48;\n  --btn-link-color: #0f766e;\n  --btn-link-border: #99f6e4;\n  --btn-link-hover-bg: #f0fdfa;\n}\n\n.portal-branded[data-button-preset='charcoal'] {\n  --btn-radius: 0.25rem;\n  --btn-primary-bg: #18181b;\n  --btn-primary-color: #fff;\n  --btn-primary-border: #18181b;\n  --btn-secondary-bg: #fafafa;\n  --btn-secondary-color: #27272a;\n  --btn-secondary-border: #d4d4d8;\n  --btn-danger-bg: #52525b;\n  --btn-danger-color: #fff;\n  --btn-danger-border: #52525b;\n  --btn-link-color: #3f3f46;\n  --btn-link-border: #e4e4e7;\n  --btn-link-hover-bg: #f4f4f5;\n}\n\n.portal-branded[data-button-preset='coral'] {\n  --btn-radius: 999px;\n  --btn-primary-bg: #f43f5e;\n  --btn-primary-color: #fff;\n  --btn-primary-border: #f43f5e;\n  --btn-secondary-bg: #fff1f2;\n  --btn-secondary-color: #be123c;\n  --btn-secondary-border: #fda4af;\n  --btn-danger-bg: #9f1239;\n  --btn-danger-color: #fff;\n  --btn-danger-border: #9f1239;\n  --btn-link-color: #e11d48;\n  --btn-link-border: #fecdd3;\n  --btn-link-hover-bg: #fff1f2;\n}\n\n.portal-brand-logo {\n  width: 2.25rem;\n  height: 2.25rem;\n  object-fit: contain;\n  border-radius: 0.35rem;\n  flex-shrink: 0;\n}\n\n.portal-brand-header {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.branding-preset-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(17rem, 1fr));\n  gap: 0.75rem;\n}\n\n.branding-preset-card {\n  border: 2px solid #e2e8f0;\n  border-radius: 0.65rem;\n  padding: 0.75rem;\n  cursor: pointer;\n  background: #fff;\n  text-align: left;\n}\n\n.branding-preset-card:hover {\n  border-color: #cbd5e1;\n}\n\n.branding-preset-card.is-selected {\n  border-color: #1d4ed8;\n  box-shadow: 0 0 0 1px #1d4ed8;\n}\n\n.branding-preset-card__title {\n  margin: 0 0 0.15rem;\n  font-size: 0.95rem;\n  font-weight: 600;\n}\n\n.branding-preset-card__desc {\n  margin: 0 0 0.65rem;\n  font-size: 0.78rem;\n  color: #64748b;\n}\n\n.branding-preset-preview {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  align-items: center;\n}\n\n.branding-preset-preview .btn-primary,\n.branding-preset-preview .btn-secondary,\n.branding-preset-preview .btn-danger,\n.branding-preset-preview .btn-link {\n  padding: 0.3rem 0.55rem;\n  font-size: 0.75rem;\n}\n\n.branding-color-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(12rem, 1fr));\n  gap: 0.75rem;\n}\n\n.branding-color-field {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.branding-color-field input[type='color'] {\n  width: 2.5rem;\n  height: 2.5rem;\n  padding: 0;\n  border: 1px solid #cbd5e1;\n  border-radius: 0.35rem;\n  cursor: pointer;\n  background: transparent;\n}\n\n.field-label {\n  display: block;\n  font-weight: 600;\n  font-size: 0.95rem;\n}\n\n.branding-logo-preview {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-top: 0.5rem;\n}\n\n.branding-logo-preview img {\n  max-width: 8rem;\n  max-height: 4rem;\n  object-fit: contain;\n  border: 1px solid #e2e8f0;\n  border-radius: 0.35rem;\n  padding: 0.35rem;\n  background: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
